module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvZmF2aWNvbi0xNngxNi5wbmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/favicon-16x16.png
// module id = cioh
// module chunks = 0